import { render, staticRenderFns } from "./NavbarAbout.vue?vue&type=template&id=461e54f8&scoped=true"
import script from "./NavbarAbout.vue?vue&type=script&lang=js"
export * from "./NavbarAbout.vue?vue&type=script&lang=js"
import style0 from "./NavbarAbout.vue?vue&type=style&index=0&id=461e54f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e54f8",
  null
  
)

export default component.exports